export const getPartnerFromURL = (search: string): string => {
  const v = new URLSearchParams(search).get('partner') || ''
  return v.trim()
}

export const sanitizePartner = (v: string): string => {
  // 영문/숫자/언더스코어/하이픈/닷만 허용, 길이 제한
  return v.replace(/[^\w.-]/g, '').slice(0, 64)
}

const STORAGE_KEY = 'xr_partner'

export const savePartner = (v: string) => {
  if (!v) return
  try {
    localStorage.setItem(STORAGE_KEY, v)
  } catch {}
}

export const loadPartner = (): string => {
  try {
    return localStorage.getItem(STORAGE_KEY) || ''
  } catch {
    return ''
  }
}
